module.exports = __webpack_public_path__ + "static/media/step3.2bd64779.svg";